import useResources from "../../../hooks/UseResources";
import * as ProfessionService from "../../../services/ProfessionService"

export default function useProfessions() {
    return useResources(ProfessionService.getAllProfessions, "data");
}
